import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import Slider from '@components/slider/Index';
import { HOMEPAGE_TESTIMONIAL } from '../../constants/homepage';
import Testimony from '@components/testimonials/Testimony';
import NextButton from '@components/slider/NextButton';
import PrevButton from '@components/slider/PrevButton';

import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import useTranslation from 'next-translate/useTranslation';

interface TestimonialsProps {
  platform: string;
  siteName: string;
}

function Testimonials(props: TestimonialsProps) {
  const { platform, siteName } = props;
  const { t } = useTranslation('home');
  return (
    <section
      className={ivclass(
        'xl:iv-pt-200 iv-pt-150 sm:iv-pt-100 iv-overflow-x-hidden',
      )}
    >
      <div className={ivclass('iv-container iv-mx-auto')}>
        <div
          className={ivclass(
            'xl:iv-pb-75 iv-pb-50 sm:iv-pb-30',
            'iv-pl-60 lg:iv-pl-75 sm:iv-pl-[45px]',
          )}
        >
          <h2
            className={ivclass(
              'xl:iv-text-heading-4xl iv-text-heading-2xl sm:iv-text-heading-xs',
              'xl:iv-m-heading-4xl iv-m-heading-2xl sm:iv-m-heading-xs',
              'iv-text-grey-100',
              'iv-font-extrabold',
            )}
          >
            {t(`testimonials.People`)}
            <span
              className={ivclass(
                'iv-relative',
                'xl:iv-top-[6px] iv-top-[4px] sm-iv-top-0',
                'xl:iv-ml-20 iv-ml-15 iv-mr-5 sm:iv-ml-9 sm:iv-mr-3',
                'xl:iv-h-[72px] iv-h-[54px] sm:iv-h-[28px]',
                'xl:iv-w-[74px] iv-w-[55px] sm:iv-w-[28px]',
                'iv-inline-block',
              )}
            >
              <ImageComponent
                elementype="native"
                src={`${process.env.NEXT_PUBLIC_SHARED_CDN_URL}/logos/invideo-logo-heart.svg`}
                alt="logo"
                loading="lazy"
                width="74"
                height="72"
              />
            </span>{' '}
            {t(`testimonials.invideo`, {
              name: siteName,
            })}
          </h2>
        </div>
      </div>
      <Slider
        sliderWrapperClasses={
          'xl:iv-ml-[140px] lg:iv-ml-40 md:iv-ml-25 sm:iv-ml-20'
        }
        renderButtons={(
          scrollPrev,
          scrollNext,
          prevBtnEnabled,
          nextBtnEnabled,
        ) =>
          platform === 'mobile' || platform === 'tablet' ? (
            <React.Fragment />
          ) : (
            <React.Fragment>
              <PrevButton
                clickHandler={scrollPrev}
                isEndReached={prevBtnEnabled}
              />
              <NextButton
                clickHandler={scrollNext}
                isEndReached={nextBtnEnabled}
              />
            </React.Fragment>
          )
        }
      >
        {HOMEPAGE_TESTIMONIAL.map(
          ({ image, statement, name, source, ratings }, i) => (
            <div key={i} className="iv-relative">
              <Testimony
                image={image}
                statement={t(`testimonials.reviews.${i}.statement`)}
                name={name}
                source={source}
                ratings={ratings}
              />
            </div>
          ),
        )}
      </Slider>
    </section>
  );
}

export default Testimonials;
